
@if (loading | async) {
    <div class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="p-4">
        <div class="member-button-container">
            <div class="member-button-group">
                <button mat-raised-button class="action-button header-button d-flex col-auto align-items-center" (click)="onInviteMemberClick()">
                    Invite Member
                </button>
                <button mat-raised-button class="action-button header-button d-flex col-auto align-items-center" (click)="onEditMemberClick()" [disabled]="!this.selectedMemberId">
                    Edit Member
                </button>
                <button mat-raised-button class="action-button header-button d-flex col-auto align-items-center" (click)="onUpdateMemberRoleClick()" [disabled]="!this.selectedMemberId">
                    Update Member Role
                </button>
                <ng-container *ngIf="selectedMemberActive">
                    <button mat-raised-button class="warn-button" (click)="onSetMemberStatusClick()" [disabled]="!this.selectedMemberId">
                        Deactivate
                    </button>
                </ng-container>
                <ng-container *ngIf="!selectedMemberActive">
                    <button mat-raised-button class="action-button" (click)="onSetMemberStatusClick()" [disabled]="!this.selectedMemberId">
                        Activate
                    </button>
                </ng-container>
            </div>
        </div>
        <div class="row justify-content-end p-1">
            <div class="col-lg-9 col-12 d-flex flex-column" id="filters-container">
                <div style="width: fit-content">
                    <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select (selectionChange)="onStatusFilterChange($event)">
                            <mat-option value="all">All</mat-option>
                            <mat-option value="active">Active</mat-option>
                            <mat-option value="inactive">Inactive</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-3 col-12 my-2">
                <mat-form-field appearance="outline" class="search-bar">
                    <mat-label class="search-bar-label">
                        <mat-icon class="search-icon">search</mat-icon>
                        <span>Search</span>
                    </mat-label>
                    <input matInput (keyup)="applySearch($event)" [(ngModel)]="keyword">
                    <button type="button" *ngIf="keyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="col-12 mt-2">
                <div class="d-flex flex-column">
                    <div *ngIf="tableLength <= 0; else orgPolicyTable">
                        <div class="row justify-content-center">
                            <div class="w-100 d-flex justify-content-center my-5" style="font-size:11pt;">
                                No Members exist for Organization.
                            </div>
                        </div>
                    </div>
                    <ng-template #orgPolicyTable>
                        <div class="table-responsive">
                            <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
                                <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                                    <ng-container [ngSwitch]="column.column">
                                        <ng-container *ngSwitchCase="'pillStatus'">
                                            <td mat-cell *matCellDef="let element">
                                                <ng-container *ngIf="element[column.column]">
                                                    <app-pill 
                                                        [backgroundColor]="this.getMemberStatusColor(element[column.column])"
                                                        fontColor="white"
                                                        [text]="element[column.column]"></app-pill>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            @if(column.renderHtml) {
                                                <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                                            } @else {
                                                <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                                            }
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onMemberClick(row)" [class.selected]="selectedMemberId === row.id"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                        No data matching the filter "{{ keyword }}"
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div *ngIf="loading.value" class="d-flex justify-content-center">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div class="d-flex paginator-row align-items-baseline mt-3">
                            <div class="col-10">
                                <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [length]="tableLength" aria-label="Select page" showFirstLastButtons></mat-paginator>
                            </div>
                            <div class="action-button d-flex col-auto align-items-center d-flex align-items-baseline">
                                <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber" step="1">
                                </mat-form-field>
                                <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
}